import { ButtonHTMLAttributes } from 'react'
import { Icon } from '../Icons/Icon'

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  label: string
  onClick: () => void
  isActive: boolean

  /**
   * Existing icon system (optional now)
   */
  iconName?: string

  /**
   * NEW: Bootstrap icon name (no "bi-" prefix)
   * Example: "telephone-plus" => <i class="bi bi-telephone-plus" />
   */
  bootstrapIcon?: string
}

export const MainButton = ({
  label,
  iconName,
  bootstrapIcon,
  onClick = () => {},
  isActive,
  ...rest
}: Props) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={isActive ? 'is-active' : undefined}
      {...rest}
    >
      <span className="osirus-agent-button-icon-container">
        {bootstrapIcon ? (
          <i className={`bi bi-${bootstrapIcon}`} aria-hidden="true" />
        ) : iconName ? (
          <Icon iconName={iconName} />
        ) : (
          // final fallback so you never render "empty"
          <i className="bi bi-dot" aria-hidden="true" />
        )}
      </span>

      <span>{label}</span>
    </button>
  )
}
